module.exports = __webpack_public_path__ + "static/pic02-7dfb76cd7730976ed514a7b78cd35914.jpg";